import { Rule } from 'antd/es/form';
import { object, string } from 'yup';

import { getFormValidator } from '@util/form/get-form-validator';

export const newPasswordFormValidation = getFormValidator(
  object().shape({
    password: string().min(8).max(24),
    repeatPassword: string().min(8).max(24),
  }),
);

export const passwordConfirmationValidation: Rule = ({ getFieldValue }) => ({
  validator(_, value) {
    if (!value || getFieldValue('password') === value) {
      return Promise.resolve();
    }
    return Promise.reject(new Error('The new password that you entered do not match!'));
  },
});
